import MyBonusesPage from './MyBonusesPage';

export default MyBonusesPage;
